import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=6c6aefae&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=6c6aefae&prod&scoped=scoped&lang=css"
import style1 from "./Details.vue?vue&type=style&index=1&id=6c6aefae&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6aefae",
  null
  
)

export default component.exports